import { HOSTNAME } from "@/config";
import StorageService from "@/services/StorageService";

const storageService = new StorageService();

export const keycloakOptions = {
  url: `${HOSTNAME}/auth/`,
  realm: "Moodbuster",
  clientId: "patient-client"
};

export class KeycloakUtil {
  keycloak: any;
  basePath = `${window.location.origin}${window.location.pathname}`;

  init(keycloak: any) {
    this.keycloak = keycloak;
  }

  async get() {
    return this.keycloak;
  }

  async updateToken() {
    const token = await this.keycloak.updateToken(70);

    if (token) {
      storageService.set("token", token);
    }

    return token;
  }

  async getKeycloakAccessToken() {
    return this.keycloak.token;
  }

  async getKeycloakAccessTokenParsed() {
    return this.keycloak.tokenParsed;
  }

  async isAuthenticated() {
    return this.keycloak.authenticated;
  }

  async isTokenExpired() {
    return this.keycloak.isTokenExpired();
  }

  async hasPermissions() {
    if (this.keycloak) {
      if (!this.keycloak.hasResourceRole("patient")) {
        return false;
      }

      if (
        !(
          this.keycloak.resourceAccess &&
          "patient-client" in this.keycloak.resourceAccess
        )
      ) {
        return false;
      }
      return true;
    } else {
      return false;
    }
  }

  async login(path = "") {
    // The ? is necessary in the redirectUri
    // Otherwise keycloak will merge the params string to the path resulting in an unknown route
    await this.keycloak.login({ redirectUri: `${this.basePath}#${path}?` });
  }

  async logout(path = "") {
    await this.keycloak.logout({ redirectUri: `${this.basePath}#/${path}` });
  }

  async getLogoutUrl() {
    return await this.keycloak.createLogoutUrl();
  }

  async getUserProfile() {
    return this.keycloak.loadUserProfile();
  }

  async getInAppBrowserToken() {
    let token = await storageService.get('inAppBrowserToken')
    token = token.replaceAll('"', '')
    if (token) return token
    else return null
  }
}
